import React from "react";
import { useEffect } from "react";
import Footer from "../components/footer";
import NavbarHome from "../components/navbar-home";
import HeaderTigaContent from "../pages/Features/header-tiga-content";
import HeaderTigaJumbotron from "../pages/Features/header-tiga-jumbotron";

export default function FeatureHeaderTiga() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <NavbarHome />
      <HeaderTigaJumbotron />
      <HeaderTigaContent />
      <Footer />
    </>
  );
}
